import React, { forwardRef } from 'react';

import './UserGallery.css';
import '../Modal-calendar.css';
import UserGallery from './UserGallery';

const UserGalleryModal = forwardRef((props, refModal) => {
  return (
    <div>
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        ref={refModal}
        aria-labelledby="userGalleryModalLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h5 className="modal-title" id="userGalleryModalLabel">
                App Gallery
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <UserGallery
                userId={props.userId}
                clientName={props.clientName}
                refresh={props.refresh}
                layoutCols={3}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default UserGalleryModal;
